module.exports = __webpack_public_path__ + "assets/img/code.48dffe6c.png";